import React from "react";
import FormField from "../../common/FormField";
import FieldValidationControls from "./FieldValidationControls";
import { DataField } from "../../../types/documentTypes";
import styles from "./DataFieldConfigurator.module.css";

interface DataFieldConfiguratorProps {
  field: DataField;
  onUpdate: (field: DataField) => void;
  onRemove: () => void;
}

const DataFieldConfigurator: React.FC<DataFieldConfiguratorProps> = ({
  field,
  onUpdate,
  onRemove,
}) => {
  return (
    <div className={styles.configurator}>
      <FormField field={field} onChange={onUpdate} />

      {["Text", "Number", "Date"].includes(field.type) && (
        <div className={styles.validationSection}>
          <h4 className={styles.sectionTitle}>Validation</h4>
          <FieldValidationControls
            type={field.type}
            validation={field.validation || {}}
            onChange={(validation) => onUpdate({ ...field, validation })}
          />
        </div>
      )}

      {field.type === "Selection" && (
        <div className={styles.optionsSection}>
          <h4 className={styles.sectionTitle}>Options</h4>
          <input
            type="text"
            placeholder="Add option and press Enter"
            className="surface-sunken"
            onKeyDown={(e) => {
              if (e.key === "Enter" && e.currentTarget.value) {
                const newOptions = [
                  ...(field.options || []),
                  e.currentTarget.value,
                ];
                onUpdate({ ...field, options: newOptions });
                e.currentTarget.value = "";
              }
            }}
          />
          <div className={styles.optionsList}>
            {field.options?.map((option, index) => (
              <div key={index} className={styles.optionItem}>
                <span>{option}</span>
                <button
                  onClick={() => {
                    const newOptions = field.options?.filter(
                      (_, i) => i !== index,
                    );
                    onUpdate({ ...field, options: newOptions });
                  }}
                >
                  ×
                </button>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className={styles.helpTextSection}>
        <input
          type="text"
          value={field.helpText || ""}
          onChange={(e) => onUpdate({ ...field, helpText: e.target.value })}
          placeholder="Help text (optional)"
          className="surface-sunken"
        />
      </div>

      <button
        type="button"
        onClick={onRemove}
        className="btn btn-sm btn-outline-danger"
      >
        Remove Field
      </button>
    </div>
  );
};

export default DataFieldConfigurator;
